import { SelectedFilters } from '@/components/FilterData/types';
import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { queryFunction, queryKey } from './query';

export const useFetchTextSearch = ({
  searchQuery,
  selectedFilters,
  tenantId,
  onError,
}: {
  searchQuery: string;
  selectedFilters?: SelectedFilters;
  tenantId: string;
  onError?: (error: Error) => void;
}) => {
  return useDataGridFetcher({
    queryKey: parameters => queryKey({ searchQuery, selectedFilters, tenantId, ...parameters }),
    queryFn: parameters => queryFunction({ searchQuery, selectedFilters, tenantId, ...parameters }),
    onError,
  });
};
